export default __webpack_public_path__ + "static/media/depannage.32b4e12e.svg";